export const verifyNum = str => {
  if (str) {
    const s = str.search(/[\-\.]+/);
    if (s > -1) return false;
    // console.log('>>>>', s)
    return true;
  }
  return false;
}


// WEBPACK FOOTER //
// ./src/utils/numberUtil.js